import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';

@Injectable({ providedIn: 'root' })
export class TenantInitialNavigationService {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private tenancy = inject(TenancyContext);

  public pathAwareNavigateTo(path: string) {
    this.router.navigate([path], { relativeTo: this.activatedRoute });
  }

  public unAwareNavigateTo(path: string) {
    this.router.navigateByUrl(this.tenancy.link(path));
  }
}
